/**
 * @generated SignedSource<<e9e89f023a55aea9a546fb26a502a5b4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsBio_seller$data = {
  readonly isRewardsTier2: boolean | null;
  readonly liveStorefrontProfile: {
    readonly aboutUsUnbranded: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsBioModalLazy_seller">;
  readonly " $fragmentType": "PdpSharedDealerDetailsBio_seller";
};
export type PdpSharedDealerDetailsBio_seller$key = {
  readonly " $data"?: PdpSharedDealerDetailsBio_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsBio_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsBio_seller",
  "selections": [
    {
      "alias": "isRewardsTier2",
      "args": [
        {
          "kind": "Literal",
          "name": "listName",
          "value": "SELLER_REWARDS_2"
        }
      ],
      "kind": "ScalarField",
      "name": "isAnchorListMember",
      "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "kind": "LinkedField",
      "name": "liveStorefrontProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "aboutUsUnbranded",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsBioModalLazy_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "044c0042292ef3812bdbff8a1ccef2fa";

export default node;
